import { Medlemskapstype } from '../api/medlemskapAPI';

export enum MedlemskapTypeId {
    Enkelt = 'Enkelt',
    EnkeltBarn = 'EnkeltBarn',
    EnkeltUngVoksen = 'EnkeltUngVoksen',
    EnkeltSenior = 'EnkeltSenior',
    Familie = 'Familie',
    Husstand = 'Husstand',
    HusstandBarn = 'HusstandBarn',
    Livsvarig = 'Livsvarig',
}

const enkeltMedlemSortOrder: { [id: string]: number } = {
    EnkeltBarn: 0,
    EnkeltUngVoksen: 1,
    Enkelt: 2,
    EnkeltSenior: 3,
};

export function sortEnkeltmedlemskap(a: Medlemskapstype, b: Medlemskapstype): number {
    return enkeltMedlemSortOrder[a.id] - enkeltMedlemSortOrder[b.id] || 0;
}
